<template>
  <div class="benefits">
    <div v-if="isAmoGo()" class="benefits-container">
      <div class="bg-logo">
        <img src="../../assets/images/bg-benefits.svg" />
      </div>
      <div class="benefit-block">
        <div class="benefit" v-for="(info, index) in infos" :key="index">
          <img :src="info.icon" :alt="info.icon" />
          {{ info.title }}
        </div>
      </div>
      <img src="../../assets/images/logo.svg" alt="Amo delivery" />
    </div>
    <div v-else class="benefits-container secondary-benefits">
      <div class="text-container">
        <span class="bold-text">Cote </span>
        <span>suas rotas com </span>
        <span class="bold-text">múltiplos pontos </span>
        <span>de </span>
        <span class="bold-text">coleta </span>
        <span>e </span>
        <span class="bold-text">entrega </span>
        <span>e </span>
        <span class="bold-underline">chame </span>
        <span>um entregador</span>
      </div>
      <img src="../../assets/images/amo.svg" alt="Amo delivery" style="" class="icon-amogo-img" />
      <img src="../../assets/images/icon-amogo.svg" alt="Amo delivery" class="icon-amogo" />
      <img src="../../assets/images/logoAmogo.png" alt="Amo delivery" class="logo-amogo" />
    </div>
  </div>
</template>


<script>
import phone from "../../assets/images/phone-off.svg";
import shopping from "../../assets/images/shopping-cart.svg";
import heart from "../../assets/images/heart.svg";
import common from "../../mixins/common";

export default {
  name: "Benefits",
  mixins: [common],
  data() {
    return {
      infos: [
        { icon: phone, title: "Esqueça o telefone." },
        { icon: shopping, title: "Compre e receba em casa." },
        { icon: heart, title: "Apaixone-se." },
      ],
    };
  },
  methods: {
    isAmoGo() {
      const client_type = this.clientType;
      if (client_type === "amogo") {
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
